/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AuditLogExtendedDataAuth } from '../models/AuditLogExtendedDataAuth';

/**
* Extended data associated with the audit log entry.
*/
export class AuditLogExtendedData {
  'auth'?: AuditLogExtendedDataAuth;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "auth",
      "baseName": "auth",
      "type": "AuditLogExtendedDataAuth",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AuditLogExtendedData.attributeTypeMap;
  }

  public constructor() {
  }
}

